// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Loader_spinnerContainer__2cRfP","loadingSpinner":"Loader_loadingSpinner__3RlsS","spinner":"Loader_spinner__3Mpl4"};